import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/storage'
import 'firebase/functions'
import 'firebase/analytics'

const firebaseApp = firebase.initializeApp({
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_FIREBASE_DB_URL,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID,
  measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID
})

export const core = firebase

export const functions = firebaseApp.functions('us-east1')

export const functionsSP = firebaseApp.functions('southamerica-east1')

export const app = firebaseApp

export const analytics = firebaseApp.analytics()

export const auth = firebaseApp.auth()
window.auth = auth

export const db = firebaseApp.firestore()

// export const storage = firebaseApp.storage('gs://gestorcreddev-bucket-files')
export const storage = firebaseApp.storage()

auth.onIdTokenChanged(user => {
  if (user) {
    analytics.setUserId(user.uid)
    user.getIdTokenResult().then(token => {
      analytics.setUserProperties({
        email: token.claims.email,
        company: token.claims.companyId,
        branch: token.claims.branchId,
        profile: token.claims.profile
      })
    })
  }
})
